/**
 * @generated SignedSource<<f29a232b82fd47201803bb5c22d43b74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "TokenResponse",
    "kind": "LinkedField",
    "name": "token",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tokenType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "signInComponentsTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "signInComponentsTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0496183fbc416207b5bfd34e85ba8e65",
    "id": null,
    "metadata": {},
    "name": "signInComponentsTokenMutation",
    "operationKind": "mutation",
    "text": "mutation signInComponentsTokenMutation(\n  $request: TokenRequestInput\n) {\n  token(request: $request) {\n    tokenType\n    accessToken\n    refreshToken\n  }\n}\n"
  }
};
})();

node.hash = "b1c91d25c3401743789f1fe8d7b3eedc";

module.exports = node;
